import React from 'react';
import {
  FDAccordionGroup,
  FDBodyText,
  FDBox,
  FDSimpleAccordion,
  FDTextButton,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

export const RecommendationRationales = (props) => {
  const { pageContentResource } = usePageContentContext();
  const theme = useTheme();
  const { options } = props;
  const [rationalsExpanded, setRationalesExpanded] = React.useState(false);

  if (options.length === 0) {
    return null;
  }

  return (
    <FDStack spacing={2} direction={'column'}>
      <FDBox alignSelf={'center'}>
        <FDTextButton
          icon={rationalsExpanded ? 'close' : 'add'}
          label={pageContentResource.meta().field('recommendationRationale').attr('prompt')}
          onClick={() => setRationalesExpanded(!rationalsExpanded)}
        />
      </FDBox>
      {rationalsExpanded ? (
        <FDBox maxWidth={theme.dimensions.lg}>
          <FDAccordionGroup>
            {options.map((option) => {
              return (
                <FDSimpleAccordion title={option.name} expansionID={option.id}>
                  <FDBodyText value={option.description} />
                </FDSimpleAccordion>
              );
            })}
          </FDAccordionGroup>
        </FDBox>
      ) : null}
    </FDStack>
  );
};

RecommendationRationales.defaultProps = {
};

RecommendationRationales.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};
